export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10073.83fe8a61.jpg";